import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import type { NavNode } from "../lib/types";
import { Sidebar } from "./Sidebar";

interface MobileDrawerProps {
  navTree: NavNode[];
}

export function MobileDrawer({ navTree }: MobileDrawerProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <button
        className="mobile-menu-btn"
        onClick={() => setOpen(true)}
        aria-label="Open navigation menu"
      >
        <span className="hamburger-icon">☰</span>
      </button>
      {open &&
        createPortal(
          <div className="mobile-overlay" onClick={() => setOpen(false)}>
            <div
              className="mobile-drawer"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mobile-drawer-header">
                <span className="mobile-drawer-title">Navigation</span>
                <button
                  className="mobile-close-btn"
                  onClick={() => setOpen(false)}
                  aria-label="Close navigation menu"
                >
                  ✕
                </button>
              </div>
              <Sidebar navTree={navTree} onNavigate={() => setOpen(false)} />
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
